var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.14251C0 2.19573 0.767512 1.42822 1.71429 1.42822H14.2857C15.2325 1.42822 16 2.19573 16 3.14251V3.53252L8.43791 8.57481C8.33126 8.64338 8.17645 8.69233 7.99974 8.69233C7.82302 8.69233 7.66821 8.64338 7.56155 8.5748L0 3.53287V3.14251ZM0 5.24989V12.8568C0 13.8036 0.767512 14.5711 1.71429 14.5711H14.2857C15.2325 14.5711 16 13.8036 16 12.8568V5.24954L9.22649 9.76602L9.21991 9.77041L9.21989 9.77037C8.86028 10.0044 8.42847 10.1209 7.99974 10.1209C7.57101 10.1209 7.1392 10.0044 6.77959 9.77037L6.77296 9.76606L6.77299 9.76602L0 5.24989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.277885bd3e903169a4059aad698e1a10.svg";
export { ForwardRef as ReactComponent };